import { TreeSelect } from 'antd';
import styled from 'styled-components';

const TreeSelectWrapper = styled(TreeSelect)`
  .ant-select-selector {
    border-radius: 3px;
  }
  .ant-select-selection-overflow {
    flex-wrap: nowrap;
    overflow: auto;
  }

  .ant-select-selection-overflow::-webkit-scrollbar {
    display: none;
  }

  .ant-select-selection-overflow::-moz-scrollbar {
    display: none;
  }

  // .ant-tree-select-dropdown .ant-select-tree .ant-select-tree-treenode {
  //   width: 100% !important;
  // }
  .ant-select-selector {
    width: ${(props) => (props.primary ? '300px' : '100%')} !important;
  }
`;

export default TreeSelectWrapper;
